import { StartAnimationClip, StopAnimation } from 'System/Animation/AnimationHelper';
import { DragonbonesDefault, Pulse } from 'System/Animation/Clip';
import { PlaySound, StopSound } from 'System/Audio/AudioHelper';
import CardSystem from '../../CardSystem';
import BaseCardModifierHandler from './BaseCardModifierHandler';
import { IGameState } from 'State/Game/IGameState';
import { createSelector, OutputSelector } from 'reselect';
import CardStateHelper from 'State/Card/CardStateHelper';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import DragonbonesComponent from 'Component/Dragonbones';

const timerAudioSelector: OutputSelector<
    [(state: IGameState) => void],
    void,
    (hasActiveTNT: boolean, timer: number) => void
> = createSelector(
    (state: IGameState) => CardStateHelper.hasActiveModifierType(state, CardModifierType.bomb),
    (state: IGameState) => CardStateHelper.getLowestActiveTomatoBombModifierTimer(state),
    (hasActiveTomatoBomb, timer) => {
        if (!hasActiveTomatoBomb) {
            StopSound('Tomatobomb_3moveleft');
            return;
        }

        if (timer <= 3 && timer > 0) {
            // Looping sounds cannot be played more than once.
            PlaySound('Tomatobomb_3moveleft', { loop: true, allowMultipleInstances: false });
        } else {
            StopSound('Tomatobomb_3moveleft');
        }
    }
);

export default class TomatoModifierHandler extends BaseCardModifierHandler {
    public handleModifierInPlay(state: IGameState, cardSystem: CardSystem) {
        const modifierStateData = this.getModifierStateData(state);
        const currentTimer = modifierStateData.properties.timer;

        if (this.modifierComponent.properties.timer !== currentTimer) {
            const dragonbonesComponent = this.modifier.getComponentsInChildren(DragonbonesComponent)[0];
            const bombArmature: GameObject = dragonbonesComponent.gameObject;
            const textContainer = dragonbonesComponent.getSlotDisplay('1');
            const text = textContainer.children[0];

            // @ts-ignore
            text.text = currentTimer.toString();

            PlaySound('hazard-bomb-countdown');

            if (currentTimer === 1) {
                StartAnimationClip(
                    new DragonbonesDefault(bombArmature, {
                        animationName: 'countdown_1',
                    })
                );
            } else {
                StopAnimation(this.modifier);
                if (currentTimer > 1 && currentTimer < 4) {
                    StartAnimationClip(
                        new DragonbonesDefault(bombArmature, {
                            animationName: 'countdown_4_2',
                        })
                    );
                } else if (currentTimer > 4) {
                    StartAnimationClip(
                        new DragonbonesDefault(bombArmature, {
                            animationName: 'countdown_5_4',
                        })
                    );
                }
                StartAnimationClip(new Pulse(this.modifier, { repeat: 1 }, true));
            }
        }
    }

    public handleStateChange(state: IGameState, cardSystem: CardSystem) {
        super.handleStateChange(state, cardSystem);

        timerAudioSelector(state);
    }
}
